import { render, staticRenderFns } from "./addPharmacyDiglog.vue?vue&type=template&id=488fb004&scoped=true"
import script from "./addPharmacyDiglog.vue?vue&type=script&lang=js"
export * from "./addPharmacyDiglog.vue?vue&type=script&lang=js"
import style0 from "./addPharmacyDiglog.vue?vue&type=style&index=0&id=488fb004&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488fb004",
  null
  
)

export default component.exports